import NoteUnpostedCommentIndicator from './NoteUnpostedCommentIndicatorContainer';

export default NoteUnpostedCommentIndicator;